import { render, staticRenderFns } from "./AddDiagnosis.vue?vue&type=template&id=60514598&scoped=true"
import script from "./AddDiagnosis.vue?vue&type=script&lang=js"
export * from "./AddDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./AddDiagnosis.vue?vue&type=style&index=0&id=60514598&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60514598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60514598')) {
      api.createRecord('60514598', component.options)
    } else {
      api.reload('60514598', component.options)
    }
    module.hot.accept("./AddDiagnosis.vue?vue&type=template&id=60514598&scoped=true", function () {
      api.rerender('60514598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AddDiagnosis.vue"
export default component.exports